import { useMemo } from 'react'

/**
 * Duas perguntas que varios efeitos fazem antes de animar qualquer coisa:
 * o visitante pediu menos movimento? e o aparelho e de toque?
 * Lidas uma vez: nenhuma das duas muda durante a visita na pratica.
 */
export function useMedia() {
  return useMemo(
    () => ({
      reduced: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
      isTouch: window.matchMedia('(hover: none)').matches,
    }),
    [],
  )
}
